import { createContext } from "react";

export type MediaCardContextType = {
    /**
     * category context of the page, used when creating media links
     */
    categoryId?: number;

    /**
     * open links to media page in a new tab
     */
    openLinksInNewTab?: boolean;

    /**
     * display card actions in place (rather than in a collapsed menu)
     */
    displayActionsInline?: boolean;

    /**
     * should card thumbnail be displayed
     */
    showThumbnail?: boolean;
};

/**
 * media card general, common info.
 * see usage example in category-moderation.
 */
export const MediaCardContext = createContext<MediaCardContextType>({showThumbnail: true});
export default MediaCardContext;
